import { mdiChartPie } from '@mdi/js'

export default {
  title: 'Dashboard Sekolah',
  icon: mdiChartPie,
  resource: 'DashboardSchool',
  action: 'read',
  to: 'dashboard-school',
}
